<template>
	<div class="modal-container">
		<div class="modal-header">
			<h3>Novo paciente</h3>
		</div>
		<div class="modal-body">
			<div class="row">
				<div class="col-md-2">
					<div class="form-group">
						<label>CPF <div v-if="this.$store.state.user.nivel == 'regulador' || this.$store.state.user.nivel == 'administrador'" style="float: right; margin: 0px 0px 0px 15px;" class="checkbox"><label><input type="checkbox" v-model="withoutCpf">Não informar CPF</label></div></label>
						<input v-mask="'###.###.###-##'" v-model.lazy="dados.cpf" class="form-control" type="text" v-validate="withoutCpf ? '' : 'required|validarCpf'" name="cpf">
						<span class="text-danger">{{ errors.first('cpf') }}</span>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Nome</label>
						<input v-validate="'required'" name="nome" v-model="dados.nome" class="form-control" type="text">
						<span class="text-danger">{{ errors.first('nome') }}</span>
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Nome Social</label>
						<input
							name="nome_social"
							v-model="dados.nome_social"
							class="form-control"
							type="text"
						/>
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Cartão SUS</label>
						<input maxlength="15" v-validate="'required'" name="cartao-sus" v-model="dados.cartao_sus" class="form-control" type="text">
						<span class="text-danger">{{ errors.first('cartao-sus') }}</span>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-2">
					<div class="form-group">
						<label>Data de Nascimento</label>
						<input v-validate="'required'" name="data-nascimento" v-model="dados.data_nascimento" class="form-control" type="date">
						<span class="text-danger">{{ errors.first('data-nascimento') }}</span>
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Naturalidade</label>
						<input name="naturalidade" v-model="dados.naturalidade" class="form-control" type="text">
						<!-- <span class="text-danger">{{ errors.first('naturalidade') }}</span> -->
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>RG</label>
						<input v-mask="'##########'" v-model="dados.rg" class="form-control" type="text">
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Orgão emissor do RG</label>
						<input v-model="dados.orgao_emissor_rg" class="form-control" type="text">
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>UF do RG</label>
						<select v-model="dados.uf_rg" class="form-control">
									<option value>Selecione o UF...</option>
									<option value="AC">AC</option>
									<option value="AL">AL</option>
									<option value="AM">AM</option>
									<option value="AP">AP</option>
									<option value="BA">BA</option>
									<option value="CE">CE</option>
									<option value="DF">DF</option>
									<option value="ES">ES</option>
									<option value="GO">GO</option>
									<option value="MA">MA</option>
									<option value="MG">MG</option>
									<option value="MS">MS</option>
									<option value="MT">MT</option>
									<option value="PA">PA</option>
									<option value="PB">PB</option>
									<option value="PE">PE</option>
									<option value="PI">PI</option>
									<option value="PR">PR</option>
									<option value="RJ">RJ</option>
									<option value="RN">RN</option>
									<option value="RO">RO</option>
									<option value="RR">RR</option>
									<option value="RS">RS</option>
									<option value="SC">SC</option>
									<option value="SE">SE</option>
									<option value="SP">SP</option>
									<option value="TO">TO</option>
								</select>
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Data de emissão do RG</label>
						<input v-model="dados.data_emissao_rg" class="form-control" type="date">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-2">
					<div class="form-group">
						<label>Sexo</label>
						<select v-validate="'required'" name="sexo" v-model="dados.sexo" class="form-control">
									<option :value="SEXO.MASCULINO">Masculino</option>
									<option :value="SEXO.FEMININO">Feminino</option>
								</select>
						<span class="text-danger">{{ errors.first('sexo') }}</span>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>Estado civil</label>
						<select v-validate="'required'" name="estado-civil" v-model="dados.estado_civil" class="form-control">
									<option :value="ESTADO_CIVIL.SOLTEIRO">Solteiro (a)</option>
									<option :value="ESTADO_CIVIL.CASADO">Casado (a)</option>
									<option :value="ESTADO_CIVIL.DESQUITADO">Desquitado (a)</option>
									<option :value="ESTADO_CIVIL.DIVORCIADO">Divorciado (a)</option>
									<option :value="ESTADO_CIVIL.VIUVO">Viúvo (a)</option>
								</select>
						<span class="text-danger">{{ errors.first('estado-civil') }}</span>
					</div>
				</div>

				<div class="col-md-2">
					<div class="form-group">
						<label>Telefone</label>
						<input v-validate="'required|min:13'" name="telefone" v-mask="['(##)#####-####', '(##)####-####']" v-model="dados.telefone" class="form-control" type="text">
						<span class="text-danger">{{ errors.first('telefone') }}</span>
					</div>
				</div>
				<div class="col-md-5">
					<div class="form-group">
						<label>Ocupação</label>
						<input v-model="dados.ocupacao" class="form-control" type="text">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>Nome da mãe</label>
						<input v-validate="'required'" name="nome-mae" v-model="dados.nome_mae" class="form-control" type="text">
						<span class="text-danger">{{ errors.first('nome-mae') }}</span>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>Nome do pai</label>
						<input v-model="dados.nome_pai" class="form-control" type="text">
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>Nome do responsável</label>
						<input v-model="dados.nome_responsavel" class="form-control" type="text">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-2">
					<div class="form-group">
						<label>CEP</label>
						<input v-validate="'required'" v-mask="['#####-###']" v-model="dados.cep" name="cep" class="form-control" type="text" @blur="getEndereco()" ref="cep">
						<span class="text-danger">{{ errors.first('cep') }}</span>
					</div>
				</div>
				<div class="col-md-5">
					<div class="form-group">
						<label>Endereço</label>
						<input v-model="dados.endereco" class="form-control" type="text">
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Número</label>
						<input v-model="dados.numero_endereco" class="form-control" type="text" ref="numero_endereco">
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>Bairro</label>
						<input v-model="dados.bairro" class="form-control" type="text">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-5">
					<div class="form-group">
						<label>Complemento</label>
						<input v-model="dados.complemento_endereco" class="form-control" type="text">
					</div>
				</div>

				<div class="col-md-5">
					<div class="form-group">
						<label>Cidade</label>
						<input :disabled="true" v-model="dados.cidade" class="form-control" type="text">
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>UF</label>
						<input :disabled="true" v-model="dados.uf" class="form-control" type="text">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-2">
					<div class="form-group">
						<label>Tipo de certidão</label>
						<select v-model="dados.tipo_certidao_auxiliar" class="form-control">
									<option value>--Selecione--</option>
									<option :value="TIPO_CERTIDAO.NASCIMENTO">Nascimento</option>
									<option :value="TIPO_CERTIDAO.CASAMENTO">Casamento</option>
									<option :value="TIPO_CERTIDAO.SEPARACAO">Separação/Divórcio</option>
								</select>
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Cartório</label>
						<input v-model="dados.cartorio_auxiliar" class="form-control" type="text">
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Livro</label>
						<input v-model="dados.livro_auxiliar" class="form-control" type="text">
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Folha</label>
						<input v-model="dados.folha_auxiliar" class="form-control" type="text">
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Registro</label>
						<input v-model="dados.registro_auxiliar" class="form-control" type="text">
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group">
						<label>Data de emissão</label>
						<input v-model="dados.data_emissao_auxiliar" class="form-control" type="date">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label>Situação</label>
						<select v-validate="'required'" name="situacao" v-model="dados.situacao" class="form-control">
									<option :value="SITUACAO.ATIVA">Ativo</option>
									<option :value="SITUACAO.INATIVA">Inativo</option>
								</select>
						<span class="text-danger">{{ errors.first('situacao') }}</span>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label>Anotações</label>
						<textarea v-model="dados.anotacoes" class="form-control" rows="7"></textarea>
						<span class="text-danger" v-if="withoutCpf">Justifique por qual motivo o cadastro está sendo realizado sem CPF</span>
					</div>
				</div>
			</div>
			<div class="row" v-if="withoutCpf">
				<div class="col-md-12">
					<div class="form-group">
						<label>GEP</label>
						<input v-validate="'required'" v-model="dados.gep" class="form-control" type="text" />
						<span class="text-danger">Informe o número do GEP referente ao cadastro SEM CPF</span>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div class="text-right" style="float:right">
				<button type="button" ref="btnPaciente" class="btn btn-default" @click="$emit('close')">
							<i class="fa fa-reply"></i> Voltar
						</button>
				<button @click="salvar()" type="button" ref="btnPaciente" class="btn btn-primary">
							<i class="fa fa-save"></i> Salvar
						</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import CPF from "gerador-validador-cpf";
import {
	mask
} from 'vue-the-mask';
import {
	SEXO,
	SITUACAO,
	ESTADO_CIVIL,
	TIPO_CERTIDAO
} from "@/constants";
export default {
	directives: {
		mask
	},
	inject: ["$validator"],
	props: ['cidadeUnidadeSolicitante'],
	computed: {
		SEXO: function() {
			return SEXO;
		},
		SITUACAO: function() {
			return SITUACAO;
		},
		ESTADO_CIVIL: function() {
			return ESTADO_CIVIL;
		},
		TIPO_CERTIDAO: function() {
			return TIPO_CERTIDAO;
		},
	},
	data: () => ({
		withoutCpf: false,
		dados: {
			nome: "",
			situacao: 1,
			telefone: "",
			cartao_sus: "",
			data_nascimento: "",
			naturalidade: "",
			sexo: "",
			rg: "",
			orgao_emissor_rg: "",
			uf_rg: "",
			data_emissao_rg: "",
			cpf: "",
			estado_civil: 0,
			nome_mae: "",
			nome_pai: "",
			nome_responsavel: "",
			ocupacao: "",
			cep: "",
			endereco: "",
			numero_endereco: "",
			bairro: "",
			complemento_endereco: "",
			cidade: "",
			uf: "",
			tipo_certidao_auxiliar: "",
			cartorio_auxiliar: "",
			livro_auxiliar: "",
			folha_auxiliar: "",
			registro_auxiliar: "",
			data_emissao_auxiliar: "",
			anotacoes: "",
			cidadeUnidadeSolicitante: null
		},
	}),
	created() {
        this.$validator.extend("validarCpf", {
            getMessage: field => "O CPF informado não é válido.",
            validate: value => {
                return CPF.validate(value);
            }
        });
    },
	methods: {
		reset() {
			this.dados = {
				nome: "",
				situacao: 1,
				telefone: "",
				cartao_sus: "",
				data_nascimento: "",
				naturalidade: "",
				sexo: 1,
				rg: "",
				orgao_emissor_rg: "",
				uf_rg: "",
				data_emissao_rg: "",
				cpf: "",
				estado_civil: 0,
				nome_mae: "",
				nome_pai: "",
				nome_responsavel: "",
				ocupacao: "",
				cep: "",
				endereco: "",
				numero_endereco: "",
				bairro: "",
				complemento_endereco: "",
				cidade: "",
				uf: "",
				tipo_certidao_auxiliar: "",
				cartorio_auxiliar: "",
				livro_auxiliar: "",
				folha_auxiliar: "",
				registro_auxiliar: "",
				data_emissao_auxiliar: "",
				anotacoes: "",
				cidadeUnidadeSolicitante: null
			}
		},
		getEndereco() {
			if (this.dados.cep && this.dados.cep != '') {
				this.$store.commit('TOGGLE_LOADING');
				axios.get(`https://viacep.com.br/ws/${this.dados.cep}/json/`).then(response => {
					// console.log(response.data);
					if (response.data.erro) {
						this.$swal({
							type: "warning",
							title: "Digite um CEP válido!",
							text: ""
						}).then(() => {
							this.dados.cep = '';
							this.dados.endereco = '';
							this.dados.bairro = '';
							this.dados.cidade = '';
							this.dados.uf = '';
							this.$refs.cep.focus();
						});
						return false;
					}

					this.dados.endereco = response.data.logradouro;
					this.dados.bairro = response.data.bairro;
					this.dados.cidade = response.data.localidade;
					this.dados.uf = response.data.uf;
					this.$store.commit('TOGGLE_LOADING');

					this.$refs.numero_endereco.focus();

				}).catch(() => {
					this.$swal({
						type: "warning",
						title: "Não conseguimos buscar seu endereço!",
						text: "Por favor, digite um CEP válido!"
					});
				});
			}
		},
		salvar() {
			this.$validator.validate().then(result => {
				this.dados.cidadeUnidadeSolicitante = this.$props.cidadeUnidadeSolicitante;
				if (result) {
					axios.post(
						`${this.$store.state.serverURI}/api/cadastros/pacientes/create`,
						this.dados,
						this.$store.getters.getHeaderAuth
					).then(response => {
						if (response.data.created_at) {
							this.$swal({
								type: "success",
								title: "Paciente criado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							this.reset();
							this.$emit("pacienteSelecionado", response.data);
						} else {
							this.$swal({
								type: "warning",
								title: "Não foi possível cadastrar!",
								text: "O paciente não reside no mesmo munícipio da unidade solicitante.",
							});
						}
					}).catch(error => {
						var erros = error.response.data.message + " ";
						for (var erro of Object.values(error.response.data.errors)) {
							erros += erro + " \n";
						}
						this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
					});
				}
			});
		},
	},
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// formAddPaciente.vue?65353e0e